import React, { Component } from 'react';

import DriveEtaRoundedIcon from '@material-ui/icons/DriveEtaRounded';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { customFetchV2 } from '../../../services/custom-fetch-v2.ts';
import Button from '../../bits/Button.jsx';
import Loading from '../Loading.jsx';
import TripOverviewPanel from './TripOverviewPanel.jsx';

const StyledTripsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 35px;
`;

class TripsList extends Component {
  state = {
    isLoading: true,
    trips: [],
  };

  componentDidMount() {
    // We probably also want to do this if we detect the deviceFilter prop has changed
    this.loadTrips();
  }

  loadTrips = (nextCursor) => {
    this.setState({ isLoading: true });

    let url = '/api/v2/trips?';
    if (nextCursor) {
      url += `&next=${nextCursor}`;
    }

    const { deviceFilter } = this.props;
    if (deviceFilter) {
      url += `&device-filter=${deviceFilter.join(',')}`;
    }

    return customFetchV2(url, {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Ooops');
        }

        return response.data;
      })
      .then((json) => {
        const newTrips = nextCursor ? this.state.trips.concat(json.results) : json.results;

        this.setState({
          trips: newTrips,
          nextCursor: json.nextCursor,
          isLoading: false,
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });

        throw e;
      });
  };

  renderNoTrips = () => {
    if (this.state.isLoading) {
      return (
        <div className="section">
          <Loading />
        </div>
      );
    }

    return (
      <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
        <div style={{ fontSize: '100px' }}>
          <DriveEtaRoundedIcon fontSize="inherit"/>
        </div>
        <p>
          It looks like your tracker hasn&apos;t recorded any trips yet! Try taking your
          vehicle out for a drive and then check back here.
        </p>
      </div>
    );
  }

  renderTripPanels = () => this.state.trips.map((trip, ix) => (
    <TripOverviewPanel key={ix} trip={trip} />
  ));

  renderTripContent = () => (
      <>
        {this.renderTripPanels()}
        <Button
          onClick={this.loadNext}
          color="secondary"
          disabled={!this.state.nextCursor}
          loading={this.state.isLoading}>
          Load more
      </Button>
      </>
  );

  hasTrips = () => this.state.trips && this.state.trips.length > 0;

  loadNext = () => {
    this.loadTrips(this.state.nextCursor);
  }

  render() {
    return (
      <StyledTripsList>
        { this.hasTrips() ? this.renderTripContent() : this.renderNoTrips() }
      </StyledTripsList>
    );
  }
}

TripsList.propTypes = {
  deviceFilter: PropTypes.array,
};


export default TripsList;
